/**
 * 客资查询条件
 *
 * conditionSelect 参数说明
 *
 * visible  -- 控制下拉显示
 * defaultText -- 当先选中显示的文字
 * treeNull -- 选中的数据为空 显示的文字
 * treeData -- 下拉数据
 * ids -- 选中的id 集合
 * */

import timeUtil from '../../common/time-util'

const state = {
  //领取类型
  receiveType: '1',

  //开始结束时间
  timeNode: {
    startTime: timeUtil.getStartDateByDateStr(getYmdToday()),
    endTime: timeUtil.getEndDateByDateStr(getYmdToday()),
  },

  //下拉
  conditionSelect: {
    //  渠道下拉
    channelSelect: {
      visible: false,
      defaultText: '全部渠道',
      selectName: 'channelSelect',
      treeNull: '全部渠道',
      treeData: [],
      ids: '',
    },

    //  拍摄地下拉
    shopSelect: {
      visible: false,
      defaultText: '全部门店',
      selectName: 'shopSelect',
      treeNull: '全部门店',
      treeData: [],
      ids: '',
    },

    //  全部人员
    staffSelect: {
      visible: false,
      defaultText: '全部人员',
      selectName: 'staffSelect',
      treeNull: '全部人员',
      treeData: [],
      ids: '',
    },

    //  全部客服
    staffService: {
      visible: false,
      defaultText: '全部客服',
      selectName: 'staffService',
      treeNull: '全部客服',
      treeData: [],
      ids: '',
    },

    //  意向等级
    staffYxlive: {
      visible: false,
      defaultText: '意向等级',
      selectName: 'staffYxlive',
      treeNull: '意向等级',
      treeData: [],
      ids: '',
    },

    //  拍摄类型
    shopType: {
      visible: false,
      defaultText: '全部类型',
      selectName: 'shopType',
      treeNull: '全部类型',
      treeData: [],
      ids: '',
    },
  },

  //客资类型
  selectKzType: '0',

  //所有id
  conditionIds: {
    channelSelect: '',
    sourcelSelect: '',
    shopSelect: '',
    staffSelect: '',
    staffYxlive: '',
    staffService: '',
    shopType: '',
  },

  //更多选项
  moOptionValue: {
    moreValue: '1',
    kind: '=',
    select: '',
    input: '',
    staffId:[],
  },

  //过滤条件
  filterSqlMap: new Map(),

  //filterString 转换为字符串
  filterString: '',

  //更多选项
  sparesql: '',
}

const getters = {
  receiveType: state => {
    return state.receiveType
  },
  timeNode: state => {
    return state.timeNode
  },
  conditionSelect: state => {
    return state.conditionSelect
  },
  selectKzType: state => {
    return state.selectKzType
  },
  conditionIds: state => {
    return state.conditionIds
  },
  moOptionValue: state => {
    return state.moOptionValue
  },
  filterSqlMap: state => {
    return state.filterSqlMap
  },
  filterString: state => {
    return state.filterString
  },
  sparesql: state => {
    return state.sparesql
  }
}

const mutations = {
  setReceiveType: (state, data) => {
    state.receiveType = data
  },
  setTimeNode: (state, data) => {
    if (data) {
      state.timeNode.startTime = data.start
      state.timeNode.endTime = data.end
    } else {
      state.timeNode.startTime = timeUtil.getStartDateByDateStr(getYmdToday())
      state.timeNode.endTime = timeUtil.getEndDateByDateStr(getYmdToday())
    }
  },

  //修改Tree 数据源  并展示
  setTreeData: (state, data) => {
    state.conditionSelect[data.treeName].treeData = data.data
    state.conditionSelect[data.treeName].visible = true
  },

  // 修改Tree 选中文字 Id 根据定义的 selectName 来判断修改那个vuex
  setChangeText: (state, data) => {
    state.conditionSelect[data.selectName].defaultText = data.data
  },

  setConditionIds: (state, data) => {
    state.conditionIds[data.selectName] = data.data

  },

  //修改客资类型
  setSelectKzType: (state, data) => {
    state.selectKzType = data
  },

  //清空搜索条件
  clearSearch: (state, data) => {
    state.conditionSelect.channelSelect.treeData = []
    state.conditionSelect.channelSelect.treeData = []
    state.conditionSelect.shopSelect.treeData = []
    state.conditionSelect.staffSelect.treeData = []
    state.conditionSelect.staffService.treeData = []
    state.conditionSelect.staffYxlive.treeData = []
    state.conditionSelect.shopType.treeData = []

    state.conditionIds = {
      channelSelect: '',
      sourcelSelect: '',
      shopSelect: '',
      staffSelect: '',
      staffYxlive: '',
      staffService: '',
      shopType: '',
    }

    state.conditionSelect.channelSelect.defaultText = '全部渠道'
    state.conditionSelect.shopSelect.defaultText = '全部门店'
    state.conditionSelect.staffSelect.defaultText = '全部人员'
    state.conditionSelect.staffService.defaultText = '全部客服'
    state.conditionSelect.staffYxlive.defaultText = '意向等级'
    state.conditionSelect.shopType.defaultText = '全部类型'

    state.selectKzType = '0'

    state.timeNode = {
      startTime: timeUtil.getStartDateByDateStr(getYmdToday()),
      endTime: timeUtil.getEndDateByDateStr(getYmdToday()),
    }
  },

  //修改更多选项value
  setMoOptionValue: (state, data) => {
    if (!data) {
      state.moOptionValue = {
        moreValue: '1',
        kind: '=',
        select: '',
        input: '',
        staffId:[],
      }
    } else {
      state.moOptionValue[data.name] = data.data
    }
  },

  //修改过滤条件
  setFilterSql: (data,key) => {
    // if (!data) {
    //   state.filterString = ''
    //   state.filterSqlMap.delete(key.name)
    // } else {
    //   state.filterSqlMap.set(data.name, data.data)
    //   let sql = ''
    //   console.log(state.filterSqlMap)
    //   state.filterSqlMap.forEach((item, key) => {
    //     sql += `${key} in (${item.join(',')}) and `
    //   })
    //   state.filterString = sql.substr(0, sql.length - 4)
    // }
    
    if (!key.data.length) {
      state.filterString = ''
      state.filterSqlMap.delete(key.name)
    } else {
      state.filterSqlMap.set(key.name, key.data)
      let sql = ''
      let reg=/^[0-9]+.?[0-9]*$/
      state.filterSqlMap.forEach((item, key) => {
        //如果是不是数字  需要加入引号
        if(reg.test(item)){
          sql += `${key} in (${item.join(',')}) and `
        }else{
          let sql1="";
          item.forEach(item1=>{
            sql1+=`\'${item1}\',`;
          })
          sql1=sql1.substr(0, sql1.length - 1);  
          sql += `${key} in (${sql1}) and `
        }
       
      })
      state.filterString = sql.substr(0, sql.length - 4)
    }
  },

  setClearFilterSql: (state, data) => {
    state.filterString = data
    state.filterSqlMap.forEach((item, key) => {
      state.filterSqlMap.delete(key)
    })
  },

  //拼接更多选项sql
  setSparesql: (state, data) => {
    state.sparesql = data
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/kz-condition/kz-condition.js